
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 .1C4.5.1.1 4.5.1 10s4.4 9.9 9.9 9.9 9.9-4.4 9.9-9.9S15.5.1 10 .1zm5 7.7l-5.7 6.4c-.2.2-.5.3-.8.3-.2 0-.5-.1-.7-.2l-3.2-2.6c-.2-.2-.4-.5-.4-.8 0-.3.1-.6.4-.8.4-.4 1-.4 1.4-.1l2.3 1.9 5.1-5.5c.4-.4 1-.5 1.5-.1.2.2.4.5.4.7 0 .3-.1.6-.3.8z"}})])
          )
        }
      }
    